import { isLoggedIn } from './apiRequests';
import { store } from '../store';
import { loggedIn } from '../state/loginSlice';

// Called on app boot (before Redux rehydrate lifts) and on tab-visibility
// changes. Two responsibilities:
//   1. If Redux thinks we're logged in, verify the cookie/JWT is still valid
//      with the API; if not, dispatch USER_LOGOUT to wipe stale state.
//   2. If Redux thinks we're logged OUT but the API says we have a valid
//      session (cookie survived a reload, OAuth/OIDC redirect landing),
//      hydrate Redux from the validatesession payload — same shape as
//      POST /v1/login. This replaces the old /v1/me round-trip.
export async function checkLoginStatusAndRouteAsNeeded() {
    const LoggedIn = store.getState().login.value;
    if (LoggedIn) {
        try {
            const res = await isLoggedIn();
            // Refresh capability flags in case backend-side group membership
            // changed since this tab was opened. Cheap; one round-trip we
            // were making anyway.
            const data = res && res.data;
            if (data && typeof data === 'object' && data.username) {
                store.dispatch(loggedIn(data));
            }
        } catch {
            store.dispatch({ type: 'USER_LOGOUT' });
        }
    } else {
        // No persisted Redux session, but the cookie may still be valid.
        // 401 here is the expected "not logged in" state, so swallow it.
        try {
            const res = await isLoggedIn();
            const data = res && res.data;
            if (data && typeof data === 'object' && data.username) {
                store.dispatch(loggedIn(data));
            }
        } catch {
            // genuinely logged out — nothing to do
        }
    }
}
